/*cc接口及错误提示封装*/
import {resCode} from "./ISdkResponseCode";
import CONFERENCEMEET from "../languages/zh-cn";
//CC接口
/*get current user info
*userInfo
* */
export  let userInfo = (res)=>{
    console.log(res);
    if(res.status == 200){
        return {
            code:0,
            data:res.data.user[0]
        }
    }else {
        return {
            code:1,
            info:'获取用户失败'
        }
    }
};
/**
 *登录：location
 * parameters: res
 * return:（Object）code:0or1,info:'ok'or'errorInfo'，data:返回的数据
 * **/
export let locationInfo = (res)=>{
    if(res.status){
        if(res.data.status == 200){
            return  {
                code:0,
                info:'ok',
                data:res.data.serverAddress
            }
        }else if(res.data && res.data.status){
            return ccErrInfo(res.data.status)
        }else if(res.status == 500){
            return {
                code:1,
                info:CONFERENCEMEET.LOGIN_FAILER_INFO_ABOUT_OTHER,
                data:null
            }
        }
    }else if(res.message && res.message == "timeout of 30000ms exceeded"){
      return {
        code: 1,
        info:CONFERENCEMEET.JOIN_ROOM_FAILER_OTHER,
        isRetry:true
      };
    }else {
        return {
            code:1,
            info:CONFERENCEMEET.LOGIN_FAILER_INFO_ABOUT_NET
        }
    }
};
export let uloginInfo = (res)=>{
    if(res.status){
        if(res.data.status == 200){
            return info = {
                code:0,
                info:'ok',
                data:{
                    sid:res.data.sid,
                    cid:res.data.cid,
                    uid:res.data.uid
                }
            }
        }else if(res.data && res.data.status){
            return ccErrInfo(res.data.status)
        }else if(res.status == 500){
            return info = {
                code:1,
                info:CONFERENCEMEET.LOGIN_FAILER_INFO_ABOUT_OTHER,
                data:null
            }
        }
    }else if(res.message && res.message == "timeout of 30000ms exceeded"){
      return {
        code: 1,
        info:CONFERENCEMEET.JOIN_ROOM_FAILER_OTHER,
        isRetry:true
      };
    }else {
        return info = {
            code:1,
            info:CONFERENCEMEET.LOGIN_FAILER_INFO_ABOUT_NET
        }
    }
};
export let uloginSessionKey = (res)=>{
    console.log(res);
    if(res.status){
       if(res.data.status == 200){
           return {
               code:0,
               info:'ok',
               data:{
                   sid:res.data.sid,
                   cid:res.data.cid,
                   uid:res.data.uid
               }
           }
       }else {
           return {
               status:res.data.status,
               code:1,
               info:CONFERENCEMEET.LOGIN_FAILER_INFO_ABOUT_NET,
               data:{
                   uid:res.data && res.data.uid ? res.data.uid : null,
                   cid:res.data && res.data.cid ? res.data.cid : null,
               }
           }
       }
   }else{
       return {
           code:1,
           info:CONFERENCEMEET.LOGIN_FAILER_INFO_ABOUT_NET
       }
   }
}

function ccErrInfo(code) {
    //不需要重试：1200：房间不存在
    if(code != 200){
        return {
            code: 1,
            info:resCode[`${code}`],
            isRetry:true
        };
    }else{
        return {
            code: 1,
            info:resCode[`${code}`],
            isRetry:true
        };
    }
}
/*获取群协议*/
export  function groupInfo(res){
    if(res.status){
        if(res.data.status == 200){
            return{
                code:0,
                info:res.data.fixedgroups[0]
            }
        }else{
            return{
                code:1,
                info:CONFERENCEMEET.LOGIN_FAILER_INFO_JOINROOMFAILE
            }
        }
    }else{
        return{
            code:1,
            info:CONFERENCEMEET.LOGIN_FAILER_INFO_JOINROOMFAILE
        }
    }
}
/*获取群用户信息*/
export function groupMemberInfo(res) {
    if(res.status){
        if(res.data.status == 200){
            return{
                code:0,
                info:res.data.fixedgroups_user
            }
        }
    }
}
